/** Logo style pictures: the step-2 chips and the /studio/logo gallery. */
import type { LogoStyle } from '@codasc/studio-shared';
import type { ReactNode } from 'react';

/**
 * Small pictures of each logo style, so "Initials" or "Abstract shape" means
 * something to someone who has never briefed a designer. They are also the
 * first answer to "what kind of logo do you make": every one is flat shapes.
 */
export const LOGO_STYLE_ICONS: Partial<Record<LogoStyle, ReactNode>> = {
  wordmark: (
    <text x="12" y="16" textAnchor="middle" fontSize="11" fontWeight="800" fill="currentColor">
      Aa
    </text>
  ),
  monogram: (
    <>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <text x="12" y="15.5" textAnchor="middle" fontSize="9" fontWeight="800" fill="currentColor">
        JD
      </text>
    </>
  ),
  combination: (
    <>
      <circle cx="6" cy="12" r="4" fill="currentColor" />
      <rect x="12" y="9" width="10" height="2.4" rx="1" fill="currentColor" />
      <rect x="12" y="13" width="7" height="2.4" rx="1" fill="currentColor" opacity="0.6" />
    </>
  ),
  icon: <path d="M4 12 L12 5 L20 12 V20 H4 Z M10 20 V15 H14 V20" fill="currentColor" />,
  abstract: (
    <>
      <circle cx="9" cy="10" r="6" fill="currentColor" opacity="0.55" />
      <path d="M10 20 L16 8 L22 20 Z" fill="currentColor" />
    </>
  ),
  mascot: (
    <>
      <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="9" cy="10.5" r="1.4" fill="currentColor" />
      <circle cx="15" cy="10.5" r="1.4" fill="currentColor" />
      <path
        d="M8.5 14.5 Q12 17.5 15.5 14.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </>
  ),
};
